import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Visualization } from './components/Visualization';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Solution data-id="element-6" />
        <Visualization data-id="element-7" />
        <Benefits data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Testimonials data-id="element-10" />
        <CTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}